var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isSoleOwnership)?_c('buyers',{attrs:{"data-test-id":"buyers","project-id":_vm.projectId,"buyers":_vm.buyers}}):_vm._e(),_c('contracts-box',{attrs:{"data-test-id":"contracts-box","contracts":_vm.contracts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }